enum FormTypesEnum {
  CREATE = 'create',
  EDIT = 'edit'
}

export default FormTypesEnum;
